import { Route } from "react-router-dom";

import CoachHome from "@/pages/coach/CoachHome";
import CoachCircles from "@/pages/coach/CoachCircles";
import CircleDashboard from "@/pages/coach/CircleDashboard";
import MeinKreis from "@/pages/coach/MeinKreis";
import MeinKreisEdit from "@/pages/coach/MeinKreisEdit";
import ClientPulse from "@/pages/coach/ClientPulse";
import MembersHealth from "@/pages/coach/MembersHealth";
import CircleTile from "@/pages/coach/CircleTile";
import InnerCircle from "@/pages/coach/InnerCircle";
import Bookings from "@/pages/coach/Bookings";
import Earnings from "@/pages/coach/Earnings";
import Availability from "@/pages/coach/Availability";
import Collab from "@/pages/coach/Collab";
import Analytics from "@/pages/coach/Analytics";
import Content from "@/pages/coach/Content";
import Methods from "@/pages/coach/Methods";
import Plans from "@/pages/coach/Plans";
import Offerings from "@/pages/coach/Offerings";
import Ads from "@/pages/coach/Ads";
import Recommendations from "@/pages/coach/Recommendations";
import ClientDetail from "@/pages/coach/ClientDetail";
import Profile from "@/pages/coach/Profile";
import Verify from "@/pages/coach/Verify";
import ConsentForms from "@/pages/coach/ConsentForms";
import CoachSetup from "@/pages/coach/CoachSetup";
import CoachSettings from "@/pages/coach/Settings";
import RefundPolicy from "@/pages/coach/settings/RefundPolicy";
import RescheduleSettings from "@/pages/coach/settings/RescheduleSettings";
import Branding from "@/pages/coach/settings/Branding";
import WeeklyDigest from "@/pages/coach/settings/WeeklyDigest";
import CoachCredits from "@/pages/coach/settings/Credits";
import CheckInTemplate from "@/pages/coach/settings/CheckInTemplate";
import CoachSupport from "@/pages/coach/Support";
import CoachReferral from "@/pages/coach/Referral";
import InnerCircleInvites from "@/pages/coach/InnerCircleInvites";
import Collectives from "@/pages/coach/Collectives";
import CollectiveDetail from "@/pages/coach/CollectiveDetail";
import CoachUpgrade from "@/pages/coach/Upgrade";
import CoachTour from "@/pages/coach/Tour";
import ProfessionalOnboarding from "@/pages/coach/ProfessionalOnboarding";
import ClientWins from "@/pages/coach/ClientWins";
import CoachHelp from "@/pages/coach/Help";
import AiAssistant from "@/pages/coach/assistant";

// Children of the /app layout route — coach dashboard surfaces (/app/coach/*).
export const coachRoutes = (
  <>
    <Route path="coach" element={<CoachHome />} />
    <Route path="coach/bookings" element={<Bookings />} />
    <Route path="coach/earnings" element={<Earnings />} />
    <Route path="coach/availability" element={<Availability />} />
    <Route path="coach/collab" element={<Collab />} />
    <Route path="coach/analytics" element={<Analytics />} />
    <Route path="coach/content" element={<Content />} />
    <Route path="coach/methods" element={<Methods />} />
    <Route path="coach/plans" element={<Plans />} />
    <Route path="coach/offerings" element={<Offerings />} />
    <Route path="coach/ads" element={<Ads />} />
    <Route path="coach/recommendations" element={<Recommendations />} />
    <Route path="coach/client/:id" element={<ClientDetail />} />
    <Route path="coach/consent-forms" element={<ConsentForms />} />
    <Route path="coach/setup" element={<CoachSetup />} />
    <Route path="coach/settings" element={<CoachSettings />} />
    <Route path="coach/settings/refund-policy" element={<RefundPolicy />} />
    <Route path="coach/settings/reschedule" element={<RescheduleSettings />} />
    <Route path="coach/settings/branding" element={<Branding />} />
    <Route path="coach/settings/weekly-digest" element={<WeeklyDigest />} />
    <Route path="coach/settings/credits" element={<CoachCredits />} />
    <Route path="coach/settings/check-in" element={<CheckInTemplate />} />
    <Route path="coach/support" element={<CoachSupport />} />
    <Route path="coach/referral" element={<CoachReferral />} />
    <Route path="coach/inner-circle-invites" element={<InnerCircleInvites />} />
    <Route path="coach/collectives" element={<Collectives />} />
    <Route path="coach/collectives/:id" element={<CollectiveDetail />} />
    <Route path="coach/upgrade" element={<CoachUpgrade />} />
    <Route path="coach/tour" element={<CoachTour />} />
    <Route path="coach/professional" element={<ProfessionalOnboarding />} />
    <Route path="coach/client-wins" element={<ClientWins />} />
    <Route path="coach/help" element={<CoachHelp />} />
    <Route path="coach/profile" element={<Profile />} />
    <Route path="coach/verify" element={<Verify />} />
    <Route path="coach/circles" element={<CoachCircles />} />
    <Route path="coach/circles/inner" element={<InnerCircle />} />
    <Route path="coach/circles/local" element={<CircleDashboard type="local" />} />
    <Route path="coach/circles/mein-kreis" element={<MeinKreis />} />
    <Route path="coach/circles/mein-kreis/edit" element={<MeinKreisEdit />} />
    <Route path="coach/client-pulse" element={<ClientPulse />} />
    <Route path="coach/assistant" element={<AiAssistant />} />
    <Route path="coach/circles/c/:circleId/members" element={<MembersHealth />} />
    <Route path="coach/circles/:type/tile/:tile" element={<CircleTile />} />
  </>
);
